module.exports = __webpack_public_path__ + "img/Appetizer.4d79a1dd.jpg";